// extracted by mini-css-extract-plugin
export default {"advanced_container":"Spacing_advanced_container__fzVVy","spaceing_img_container":"Spacing_spaceing_img_container__LymSI"};